import * as React from "react";
import { Input } from "@/components/ui/input";

/**
 * Native date input wrapper that reliably opens the browser's calendar picker
 * even after a Radix Select/Dialog has been interacted with in the same modal.
 *
 * The bug: Radix Select briefly sets `pointer-events: none` and yanks focus,
 * which suppresses the next native date picker from opening. Explicitly calling
 * `showPicker()` on click bypasses the issue.
 */
const DateInput = React.forwardRef(function DateInput({ onClick, ...props }, ref) {
  return (
    <Input
      ref={ref}
      type="date"
      onClick={(e) => {
        // showPicker() throws in older browsers/Safari; fall back to focus.
        try {
          if (typeof e.currentTarget.showPicker === "function") {
            e.currentTarget.showPicker();
          }
        } catch (_) { /* ignore */ }
        onClick?.(e);
      }}
      {...props}
    />
  );
});

export default DateInput;
